<template>
  <div class="faq ml-2">
    <h2>Frequently Asked Questions</h2>
    <div class="mt-4">
      <h5>My tests are not discovered in PyCrunch, but can be run via PyTest.</h5>
      <p>PyCrunch uses slightly different mechanics for test discovery via AST.</p>
      <div>There are two conditions in order to find tests:</div>
      <div>1. File name starts with <code>test_</code>; <code>tests_</code> or ends with <code>_test</code>; <code>_tests</code></div>
      <div>2. Test Class name has a prefix or suffix <code>Test</code> (case-sensitive)</div>
      <div>3. Test Class is a direct subclass of unittest.TestCase</div>
      <div class="mt-3">You can also try using <router-link to="/docs/configuration-file/">
        <code>deep-inheritance: true</code>
      </router-link> option, and see if that helps.</div>

      <h5 class="mt-5">Tests stuck in pending status. No coverage is drawn.</h5>
      <p>There may be two possible known issues:</p>
      <div>1. <code>pytest-coverage</code> plugin. Make sure to disable or remove it locally if you plan to run PyCrunch.
        This is just not supported because multiple coverage collection is not possible today.</div>
      <div class="mt-3">2. Unsupported version of <code>coverage</code> package.
        There were reports that is not possible to run tests using multiple cpu-cores.
        In order to mitigate this issue we recommend using well-tested version of coverage, which is 5.5 and 4.5.3:
        <div class="mt-2"><code>pip install coverage==5.5</code></div>
      </div>

      <h5 class="mt-5">Engine process stuck with no reason, new tests are not discovered, not possible to run tests.</h5>
      <p>This may happen due to some broken code or pip-package</p>
      <p>Usually, restarting engine process helps, use (in PyCharm) <code>PyCrunch->Run/Restart PyCrunch</code></p>
      <div class="mt-3 small text-secondary">You can also check terminal output, raise GitHub issue or contact support if the problem persists.</div>




    </div>
  </div>
</template>

<script>
  export default {
    name: 'help-faq.page',
  }
</script>

<style scoped>
  .trace-one {
    width: 900px;
  }
</style>